export default "__VITE_ASSET__DGrX8jtq__"